var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:['ui-select-option', { active: _vm.active }],on:{"click":_vm.onClick}},[(_vm.icon)?_c('img',{staticClass:"selector-icon",attrs:{"src":_vm.icon,"alt":"Icon"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }